import script from "./SecPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SecPanel.vue?vue&type=script&setup=true&lang=js"

import "./SecPanel.vue?vue&type=style&index=0&id=3596c007&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3596c007"]])

export default __exports__